import React from 'react'

export default function AIAssistantPanel({ aiResult }) {
  return (
    <div>
      <h5>
        AI Suggestions{' '}
        <span
          className="badge badge-secondary"
          style={{ fontSize: '0.65rem', verticalAlign: 'middle' }}
        >
          Beta
        </span>
      </h5>
      <ul>{(aiResult?.suggestions || []).map((suggestion) => <li key={suggestion}>{suggestion}</li>)}</ul>
    </div>
  )
}
